import { Modal, ModalContextProvider } from '@sequencehq/core-components'
import { Provider, useAtom } from 'jotai'
import { ReactNode } from 'react'
import { modalScreenAtom, modalTitleAtom } from './atoms/screens.atom'
import { match } from 'ts-pattern'
import { ShortcutSelectionScreen } from './screens/ShortcutSelection'
import { CancelScreen } from './screens/cancel/Cancel'
import { RenewScreen } from './screens/Renew'
import { UpgradeScreen } from './screens/Upgrade'
import { CancelConfirmationScreen } from './screens/cancel/CancelConfirmation'

const ModalContent = () => {
  const [modalTitle] = useAtom(modalTitleAtom)
  const [screen] = useAtom(modalScreenAtom)

  return (
    <>
      <Modal.Header showCloseButton withBorder>
        {modalTitle}
      </Modal.Header>
      {match(screen)
        .with('selection', () => <ShortcutSelectionScreen />)
        .with('cancel', () => <CancelScreen />)
        .with('cancel-confirm', () => <CancelConfirmationScreen />)
        .with('renew', () => <RenewScreen />)
        .with('upgrade', () => <UpgradeScreen />)
        .exhaustive()}
    </>
  )
}

export const EditScheduleShortcutsModal = (props: {
  trigger: ReactNode
}) => {
  return (
    <ModalContextProvider>
      <Modal.Trigger>{props.trigger}</Modal.Trigger>
      <Modal>
        <Provider>
          <ModalContent />
        </Provider>
      </Modal>
    </ModalContextProvider>
  )
}
